module.exports = __webpack_public_path__ + "img/user.909b07be.png";